import React, { FC } from 'react';
import { PageTrackOnLoad } from '../../../tracking/PageTrackOnLoad';
import { CodeInfos } from './legislationCode.types';
import { LegislationCode } from './LegislationCode';
import { getParametersFromUrl } from '../../../utils/url-utils/urlUtils';
import { AppWrapperWithPageLayout } from '../../../app/common-app/AppWrapperWithPageLayout';

type Props = {
  codeInfos: CodeInfos;
  isCode: boolean;
};

export const LegislationCodeApp: FC<Props> = ({ codeInfos, isCode }) => {
  const params = getParametersFromUrl(window.location.search);
  const { dateKey } = params;
  const { legId, textId } = codeInfos;
  return (
    <AppWrapperWithPageLayout>
      <PageTrackOnLoad
        data={{
          legislationType: 'code',
          text_id: textId || legId,
          ...(!isCode && { section_id: legId }),
          date: dateKey,
        }}
      />
      <LegislationCode
        codeInfos={codeInfos}
        dateKey={dateKey}
        isCode={isCode}
      />
    </AppWrapperWithPageLayout>
  );
};
